module.exports = __webpack_public_path__ + "static/media/teacher.e8cdc6a4.jpg";